import React, { ReactNode } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { theme } from '../defaults/theme';
import { GlobalStyles } from '../lib/GlobalStyles';

interface CustomThemeProviderProps {
    colors?: Record<string, any>;
    variables?: Record<string, any>;
    globalStyles?: any;
    includeFont?: boolean;
    children?: ReactNode;
}

export const CustomThemeProvider: React.FC<CustomThemeProviderProps> = ({
    colors,
    variables,
    globalStyles,
    includeFont,
    children,
}) => {
    return (
        <StyledComponentsThemeProvider
            theme={{
                colors: {
                    ...theme.colors,
                    ...colors,
                },
                variables: {
                    ...theme.variables,
                    ...variables,
                },
            }}
        >
            <>
                <GlobalStyles custom={globalStyles} includeFont={includeFont} />
                {children}
            </>
        </StyledComponentsThemeProvider>
    );
};
